import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation
} from '@angular/core';
import {
  PredictiveSearch,
  RecentListItem
} from '@com-delta-idp/mnx-sitewide-shared-core-ui';
import {
  ButtonDirective,
  CheckboxDirective,
  LinkDirective,
  SelectComponent,
  SelectedData,
  Tab
} from '@com-delta-omnichannel/mach';
import {
  BookWidgetFieldInfoTypes,
  BookWidgetFieldUpdateTypes,
  TripTypeOptions
} from '../../../../constants/book-widget.constants';
import { BookWidgetAem } from '../../../../models/book-widget-aem.interfaces';
import { BookWidgetFieldUpdateEvent } from '../../../../models/book-widget-fields-update-info.interfaces';
import { BookWidgetFields } from '../../../../models/book-widget-fields.interfaces';
import { DatepickerConfig } from '../../../../models/common.interfaces';
import {
  SearchModalEvent,
  SearchModalEventType
} from '../../../../models/search-modal-events-object.interface';
import {
  ConnectionPickerComponent,
  MulticityRoutePickerComponent
} from '../../../common';
import { BestFareOptionsComponent } from '../../../common/best-fare-options/best-fare-options.component';
import { FlightDatePickerComponent } from '../../../common/flight-date-picker/flight-date-picker.component';
import { MeetingEventCodeComponent } from '../../../common/meeting-event-code/meeting-event-code.component';
import { MultiCityDesktopAdvanceExtended } from './multi-city-desktop-advance.extended';

@Component({
  standalone: true,
  selector: 'idp-multi-city-desktop-advance',
  templateUrl: './multi-city-desktop-advance.component.html',
  styleUrls: ['./multi-city-desktop-advance.component.scss'],
  imports: [
    SelectComponent,
    CheckboxDirective,
    ButtonDirective,
    CommonModule,
    MulticityRoutePickerComponent,
    ConnectionPickerComponent,
    LinkDirective,
    BestFareOptionsComponent,
    MeetingEventCodeComponent,
    FlightDatePickerComponent
  ],
  encapsulation: ViewEncapsulation.None
})
export class MulticityDesktopAdvanceComponent extends MultiCityDesktopAdvanceExtended {
  @Input() bookWidgetFields!: BookWidgetFields;
  @Input() bookWidgetAem: BookWidgetAem = {} as BookWidgetAem;
  @Input() recentSearchList: RecentListItem[] = [];
  @Input() savedSearchList: string[] = [];
  @Input() searchModalTabs: Tab[] = [];
  @Input() predictiveSearchData!: PredictiveSearch;
  @Input() isFullscreen!: boolean;
  @Input() isAdvancedSearchExpanded = false;
  @Input() datepickerConfig: DatepickerConfig = {} as DatepickerConfig;

  @Output() infoIconClick: EventEmitter<BookWidgetFieldInfoTypes> =
    new EventEmitter<BookWidgetFieldInfoTypes>();

  @Output() addFlight: EventEmitter<void> = new EventEmitter<void>();
  @Output() removeFlight: EventEmitter<void> = new EventEmitter<void>();
  @Output() override bookWidgetFieldChange =
    new EventEmitter<BookWidgetFieldUpdateEvent>();

  @Output() swapClicked = new EventEmitter<number>();
  @Output() findFlight = new EventEmitter();
  @Output() searchModalEvent = new EventEmitter<
    SearchModalEvent<SearchModalEventType>
  >();

  @Output() searchModalTriggerClicked = new EventEmitter<SelectedData>();

  protected tripTypeOptions = TripTypeOptions;
  protected bookWidgetFieldInfoTypes = BookWidgetFieldInfoTypes;
  protected bookWidgetFieldUpdateTypes = BookWidgetFieldUpdateTypes;

  onInputFieldChange(
    event: Event,
    bookWidgetFieldUpdateType: BookWidgetFieldUpdateTypes
  ) {
    const target = event.target as HTMLInputElement;
    const emitValue: BookWidgetFieldUpdateEvent = {
      data: target.value,
      type: bookWidgetFieldUpdateType
    };
    this.bookWidgetFieldChange.emit(emitValue);
  }

  onCheckBoxChange(
    event: Event,
    bookWidgetFieldUpdateType: BookWidgetFieldUpdateTypes
  ) {
    const target = event.target as HTMLInputElement;
    const emitValue: BookWidgetFieldUpdateEvent = {
      data: target.checked,
      type: bookWidgetFieldUpdateType
    };
    this.bookWidgetFieldChange.emit(emitValue);
  }

  infoIconClickHandler(sourceIcon: BookWidgetFieldInfoTypes) {
    if (sourceIcon) this.infoIconClick.emit(sourceIcon);
  }
}
